import './OKPdfViewer.scss';

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
// @components
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { OKPdfViewer } from 'commonsComponents/OKPdfViewer.js';

class OKPDFViewer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            boxTitleHeight: 0,
            finalHeight: 0,
        };
        this.pdfTitleBoxRef = this.pdfTitleBoxRef.bind(this);
    }

    pdfTitleBoxRef(ref) {
        if (ref) {
            const boxTitleHeight = ref.getBoundingClientRect().height;
            this.setState({ boxTitleHeight });
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.viewerHeight) {
            if (this.state.finalHeight <= 0 || prevProps.viewScalableHeight != this.props.viewScalableHeight) {
                this.getHeight();
            }
        }
    }

    getHeight() {
        this.setState({ finalHeight: this.props.viewScalableHeight - this.state.boxTitleHeight });
    }

    render() {
        const {
            title,
            pdfFile,
            showLogo,
            showPagination,
            showScroll,
            displayScrollButton,
            errorComponent,
            onDownload,
            onPrint,
            viewerHeight,
            handleDocumentReaded,
            scrollButtonAction,
        } = this.props;

        return (
            <Fragment>
                <div ref={this.pdfTitleBoxRef}>
                    <ConditionalToggling condition={title !== ''}>
                        <div className={'legal-info__doc-top'}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="font-heading6--book">{title}</div>
                                </div>
                            </div>
                        </div>
                    </ConditionalToggling>
                </div>
                <div>
                    {(viewerHeight || this.state.finalHeight > 0) && (
                        <OKPdfViewer
                            showLogo={showLogo}
                            showPagination={showPagination}
                            showScroll={showScroll}
                            scrollButtonAction={scrollButtonAction}
                            displayScrollButton={displayScrollButton}
                            viewerHeight={viewerHeight ? viewerHeight : this.state.finalHeight}
                            onDownload={onDownload}
                            onPrint={onPrint}
                            errorComponent={errorComponent}
                            pdfFile={pdfFile}
                            onDocumentReaded={handleDocumentReaded}
                        />
                    )}
                </div>
            </Fragment>
        );
    }
}

OKPDFViewer.propTypes = {
    title: PropTypes.string,
    pdfFile: PropTypes.string.isRequired,
    viewerHeight: PropTypes.string.isRequired,
    onDownload: PropTypes.func,
    onPrint: PropTypes.func,
    showLogo: PropTypes.bool,
    showPagination: PropTypes.bool,
    showScroll: PropTypes.bool,
    displayScrollButton: PropTypes.bool,
    errorComponent: PropTypes.func,
    scrollButtonAction: PropTypes.func,
    handleDocumentReaded: PropTypes.func,
};

OKPDFViewer.defaultProps = {
    title: '',
    viewerHeight: '',
};

export default OKPDFViewer;
